(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    var popup = document.getElementById("ssrq");
    if (!popup || popup.__bound) return;
    popup.__bound = true;

    var form = document.getElementById("ssrqForm");
    var iframe = document.getElementById("ssrq_iframe");
    var success = document.getElementById("ssrqSuccess");
    var errBox = document.getElementById("ssrqError");
    var pageUrl = document.getElementById("ssrq_page_url");
    var product = document.getElementById("ssrq_product");
    var submitBtn = document.getElementById("ssrqSubmit");

    function openPopup(trigger) {
      popup.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("ssrq-open");

      if (errBox) { errBox.hidden = true; errBox.textContent = ""; }
      if (success) success.hidden = true;
      if (form) form.style.display = "";

      if (pageUrl) pageUrl.value = window.location.href;

      if (product) {
        var p = trigger && trigger.getAttribute("data-ss-product");
        product.value = p || "";
      }

      // focus first field
      var first = popup.querySelector("#ssrq_name");
      if (first) setTimeout(function(){ first.focus(); }, 50);
    }

    function closePopup() {
      popup.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("ssrq-open");
    }

    document.addEventListener("click", function (e) {
      var openTrigger = e.target.closest && e.target.closest("[data-ss-request]");
      if (openTrigger) {
        e.preventDefault();
        openPopup(openTrigger);
        return;
      }

      var closeTrigger = e.target.closest && e.target.closest("[data-ssrq-close]");
      if (closeTrigger) {
        e.preventDefault();
        closePopup();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && popup.getAttribute("aria-hidden") === "false") closePopup();
    });

    // Submit handling (native POST into iframe)
    if (form && iframe) {
      form.addEventListener("submit", function () {
        if (submitBtn) submitBtn.setAttribute("aria-busy", "true");
      });

      iframe.addEventListener("load", function () {
        // If the iframe loaded after submit, consider it success unless Shopify returned errors
        if (submitBtn) submitBtn.removeAttribute("aria-busy");

        // Try to detect Shopify error page content
        var doc;
        try { doc = iframe.contentDocument || iframe.contentWindow.document; } catch (e) { doc = null; }

        var hasError = false;
        if (doc) {
          var text = (doc.body && doc.body.innerText) ? doc.body.innerText.toLowerCase() : "";
          if (text.includes("error") || text.includes("problem") || text.includes("invalid")) hasError = true;
        }

        if (hasError) {
          if (errBox) {
            errBox.textContent = "Something went wrong. Please try again.";
            errBox.hidden = false;
          }
          return;
        }

        // Success UI
        if (form) form.style.display = "none";
        if (success) success.hidden = false;

        // Reset fields
        try { form.reset(); } catch (e) {}
      });
    }
  });
})();